import React, { ReactNode } from "react"
import { Text } from "dash-styled"
import styles from "./AccountMenuItem.module.css"

interface AccountMenuItemProps {
    onClick: () => void
    children: ReactNode
    testId?: string
}

export function AccountMenuItem({
    onClick,
    children,
    testId
}: AccountMenuItemProps) {
    return (
        <button
            onClick={onClick}
            className={[
                styles.AccountMenuItem,
                "flex py-2 px-5 my-2 w-full items-center"
            ].join(" ")}
            data-testid={testId}
        >
            <Text className="m-0 flex items-center">{children}</Text>
        </button>
    )
}
